import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthContext";
import { AppFooter } from "../components/AppFooter";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { ThemeToggle } from "../components/ThemeToggle";
import { t } from "../i18n";

/** Arte da tela de entrada: o símbolo do EAPace em grande escala, como um rastro de movimento ao fundo. */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  return (
    <div className="auth-screen">
      <section className="auth-art">
        <img className="auth-symbol" src="/brand/eapace-symbol.png" alt="" aria-hidden />
        <div className="content">
          <img className="auth-logo" src="/brand/eapace-lockup-dark.svg" alt="EAPace" width={196} height={44} />
        </div>
        <div className="content">
          <p className="claim">{t("Treino inteligente para ir mais longe.")}</p>
          <span className="claim-bar" aria-hidden />
          <p className="pitch">{t("Evolução em cada passada: planilhas, atividades e progresso dos seus corredores no mesmo lugar.")}</p>
        </div>
      </section>
      <section className="auth-panel">
        <div className="auth-tools">
          <LanguageSwitcher loggedIn={status === "authenticated"} compact />
          <ThemeToggle className="btn btn-ghost btn-sm" />
        </div>
        <div className="auth-card">{children}</div>
        <AppFooter className="auth-footer" />
      </section>
    </div>
  );
}
